<template>
  <section>
    <div class="container">
      <div class="archaic-upgrade-container-fluid">
        <!-- Heading Component starts here -->
        <div class="heading-row my-3">
          <h1>{{ unlockDetails ? unlockDetails.title : "" }}</h1>
        </div>
        <!-- Heading Component ends here -->

        <!-- Wrapper component starts here -->
        <div class="ancestry-neatherland-row-wrapper">
          <!-- Banner Component starts here -->
          <div class="banner-neatherland-row">
            <div class="row">
              <div class="col-lg-7">
                <div class="banner-row-content">
                  <h1>
                    {{
                      unlockDetails && unlockDetails.banner
                        ? unlockDetails.banner.title
                        : ""
                    }}
                  </h1>
                  <p
                    v-html="
                      unlockDetails && unlockDetails.banner
                        ? unlockDetails.banner.text
                        : ''
                    "
                  ></p>
                  <h3 v-if="productPrice?.variants?.length">
                    Only {{ productPrice?.variants[0]?.currencySymbol?.raw }} {{ priceText }}
                  </h3>
                  <AncestryKitRequiredPrompt v-if="isEpigenetics" class="unlock-prompt" :product="productPrice?.title" />
                  <router-link
                    v-else
                    :to="{
                      name: 'AncestryDetails',
                      params: { slug: paramValue },
                    }"
                  >
                    <button>
                      {{
                        unlockDetails && unlockDetails.banner
                          ? unlockDetails.banner.button_text
                          : ""
                      }}
                    </button>
                  </router-link>
                </div>
              </div>
              <div
                class="col-lg-5 d-flex flex-column align-items-end justify-content-end"
              >
                <div class="banner-img-neatherland">
                  <img
                    :src="
                      unlockDetails && unlockDetails.banner
                        ? unlockDetails.banner.image[0].url
                        : ''
                    "
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- Banner Component ends here -->

          <!-- Second Component starts here -->
          <div class="archaic-ancestry my-5 rounded-4">
            <p>
              {{
                unlockDetails && unlockDetails.description
                  ? unlockDetails.description.title
                  : ""
              }}
            </p>
            <h2>
              {{
                unlockDetails && unlockDetails.description
                  ? unlockDetails.description.heading
                  : ""
              }}
            </h2>
            <div class="row mt-5">
              <div class="col-lg-6">
                <div
                  :class="'archaic-ancestry-wrapper'"
                  v-html="
                    unlockDetails && unlockDetails.description
                      ? unlockDetails.description.text
                      : ''
                  "
                ></div>
              </div>
              <div class="col-lg-6">
                <div class="ancestry-neatherland-image-container">
                  <img
                    :src="
                      unlockDetails && unlockDetails.description
                        ? unlockDetails.description.image[0].url
                        : ''
                    "
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- Second Component ends here -->
        </div>
        <!-- Wrapper component ends here -->
      </div>
    </div>
  </section>
</template>
<script setup>
import "../../styles/pages/archaicNeatherland.scss";
import ProductService from "@/services/product";
import AncestryKitRequiredPrompt from "@/components/store/AncestryKitRequiredPrompt.vue";
import { defineProps, ref, computed } from "vue";
import store from "@/store";
const props = defineProps({ unlockDetails: { type: Object }, paramValue: { type: String } });
const isEpigenetics = computed(() => store.getters?.profile?.profile?.barcode?.endsWith('E') === true);
const productPrice = ref("");

ProductService.getProduct(props.paramValue)
  .then((res) => {
    productPrice.value = res
  })
  .catch((err) => {
    if (err.code == "ERR_NETWORK") {
      console.log("err.code ", err.code);
    }
  });

const priceText = computed(() => {
  if (productPrice.value.variants[0].price && productPrice.value.variants[0].price.isOnSale) {
    return productPrice.value.variants[0].price.sale / 100;
  }
  if (productPrice.value.variants[0].price && productPrice.value.variants[0].price.base) {
    return productPrice.value.variants[0].price.base / 100;
  }
  return 0;
});
</script>
